module.exports = __webpack_public_path__ + "static/media/arrowDown.8d3534fd.svg";